
import { Link } from 'react-router-dom';

export default function CoachesSection() {
  const coaches = [
    {
      name: 'TBA',
      title: 'Head Coach & Director',
      experience: '15+ years',
      certifications: ['UEFA B License', 'Youth Development Specialist'],
      image: 'https://public.readdy.ai/ai/img_res/5ecc61cc7ea1ae31fb9b5513854759ed.jpg',
      description: 'Former professional player with extensive youth coaching experience.'
    },
    {
      name: 'TBA',
      title: 'Youth Development Coach',
      experience: '8+ years',
      certifications: ['USSF National D License', 'Child Psychology Certified'],
      image: 'https://readdy.ai/api/search-image?query=Professional%20female%20soccer%20coach%20in%20her%20late%2020s%2C%20wearing%20purple%20sports%20coaching%20uniform%20and%20purple%20NextZen%20Soccer%20Academy%20jersey%2C%20warm%20smile%2C%20soccer%20field%20background%2C%20energetic%20and%20caring%20appearance%2C%20purple%20team%20colors&width=300&height=400&seq=coach-sarah-purple&orientation=portrait',
      description: 'Specializes in working with young players aged 4-12 years old.'
    },
    {
      name: 'TBA',
      title: 'Goalkeeper Coach',
      experience: '10+ years',
      certifications: ['Goalkeeper Specialist Certification', 'Sports Science Degree'],
      image: 'https://readdy.ai/api/search-image?query=Professional%20male%20goalkeeper%20coach%20in%20his%20early%2030s%2C%20athletic%20build%2C%20wearing%20purple%20goalkeeper%20training%20gear%20and%20purple%20NextZen%20Soccer%20Academy%20jersey%2C%20confident%20stance%2C%20soccer%20goal%20background%2C%20purple%20team%20colors&width=300&height=400&seq=coach-david-purple&orientation=portrait',
      description: 'Former collegiate goalkeeper with specialized training expertise.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Meet Our Coaches</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our experienced and certified coaching staff is dedicated to developing each player's potential.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {coaches.map((coach, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="relative">
                <img
                  src={coach.image}
                  alt={coach.name}
                  className="w-full h-64 object-cover object-top"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-4">
                  <div className="text-white">
                    <div className="bg-green-500 text-xs px-2 py-1 rounded-full inline-block mb-2">
                      {coach.experience}
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-1">{coach.name}</h3>
                <p className="text-blue-600 font-semibold mb-3">{coach.title}</p>
                <p className="text-gray-600 mb-4">{coach.description}</p>
                
                <div className="mb-4">
                  <h4 className="text-sm font-semibold text-gray-900 mb-2">Certifications:</h4>
                  <div className="flex flex-wrap gap-2">
                    {coach.certifications.map((cert, certIndex) => (
                      <span key={certIndex} className="bg-gray-100 text-gray-700 text-xs px-2 py-1 rounded-full">
                        {cert}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/coaches"
            className="bg-blue-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-blue-700 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            Meet All Our Coaches
          </Link>
        </div>
      </div>
    </section>
  );
}
